import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { LockIcon } from 'lucide-react';
export function BlackHoleSection() {
  return <SectionWrapper id="revelacion" withGlow data-id="element-79">
      <div className="max-w-3xl mx-auto text-center" data-id="element-80">
        <div className="inline-flex items-center gap-2 px-4 py-2 mb-8 border border-[#c9a84c]/30 rounded-full bg-[#c9a84c]/5" data-id="element-81">
          <LockIcon className="w-4 h-4 text-[#c9a84c]" aria-hidden="true" data-id="element-82" />
          <span className="text-[#c9a84c] text-sm font-medium tracking-wider uppercase" data-id="element-83">
            Lo que nadie te dice
          </span>
        </div>

        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8e6e1] mb-8 leading-tight" data-id="element-84">
          Hay algo que{' '}
          <span className="text-gold-gradient" data-id="element-85">todos los métodos ignoran</span>
        </h2>

        <p className="text-lg md:text-xl text-[#9a9aab] leading-relaxed mb-8" data-id="element-86">
          Cada libro de autoayuda, cada curso de productividad, cada coach
          motivacional...
          <span className="text-[#e8e6e1] font-medium" data-id="element-87">
            {' '}
            todos te enseñan lo mismo:
          </span>
        </p>

        <div className="space-y-4 mb-12 text-left max-w-2xl mx-auto" data-id="element-88">
          <div className="p-5 rounded-xl bg-[#16213e]/60 border border-[#3a3a5c]/50" data-id="element-89">
            <p className="text-[#9a9aab]" data-id="element-90">"Establece metas claras"</p>
          </div>
          <div className="p-5 rounded-xl bg-[#16213e]/60 border border-[#3a3a5c]/50" data-id="element-91">
            <p className="text-[#9a9aab]" data-id="element-92">"Crea hábitos diarios"</p>
          </div>
          <div className="p-5 rounded-xl bg-[#16213e]/60 border border-[#3a3a5c]/50" data-id="element-93">
            <p className="text-[#9a9aab]" data-id="element-94">"Mantén la disciplina"</p>
          </div>
        </div>

        <p className="text-xl md:text-2xl text-[#e8e6e1] font-display leading-relaxed mb-6" data-id="element-95">
          Pero hay un problema...
        </p>

        <div className="p-8 md:p-12 rounded-2xl bg-gradient-to-b from-[#16213e] to-[#1a1a2e] border-2 border-[#c9a84c]/30 mb-8" data-id="element-96">
          <p className="text-lg md:text-xl text-[#9a9aab] leading-relaxed mb-4" data-id="element-97">
            Todo eso opera en la{' '}
            <span className="text-[#e8e6e1] font-medium" data-id="element-98">capa superficial</span>{' '}
            de tu mente consciente.
          </p>
          <p className="text-xl md:text-2xl text-[#c9a84c] font-semibold" data-id="element-99">
            Pero el verdadero problema está 7 niveles más profundo.
          </p>
        </div>

        <p className="text-[#6b6b7b] text-sm italic" data-id="element-100">
          Y hasta que no llegues ahí... seguirás en el mismo ciclo.
        </p>
      </div>
    </SectionWrapper>;
}